import React, { useState, useEffect } from "react";
import { useTranslation, getI18n } from "react-i18next";
import { useDispatch } from "react-redux";
import CampaignsDetailActions from "../../redux/reducers/campaing-detail.reducer";
import { getHasSession } from "../../pages/CampaingNewDetail/CampaingNewDetail";
import { capitalizeWord } from "../../lib/utils";
import moment from "moment";
import PropTypes from "prop-types";
import ReactTooltip from "react-tooltip";
import InvestDetail from "../InvestDetail/InvestDetail";
import { useIsPhone } from "../../hooks/useIsPhone";
import chevronIcon from "../../assets/icons/Chevron-up-5254.svg";
import infoIconDebt from "../../assets/icons/info-tooltip-deuda.svg";
import infoIconShares from "../../assets/icons/info-tooltip-acciones.svg";
import infoIconConvertibleNote from "../../assets/icons/info-tooltip-notaconvertible.svg";
import "./InvestListAccordion.scss";
import "moment/locale/es";

enum ICampaingTypes {
  Debt = 1,
  Shares = 2,
  ConvertibleNote = 3
}

enum ICampaingState {
  Open = 1
}

const BusinessLine: any = {
  1: "debt",
  2: "shares",
  3: "convertibleNote"
};

const InvestListAccordion = ({ investmentData }: any) => {
  const { t } = useTranslation();
  const [active, setActive] = useState(
    investmentData && investmentData.firstElement ? investmentData.id : 0
  );
  const [help, setHelp] = useState(false);
  const dispatch = useDispatch();
  const isPhone = useIsPhone();
  const localLocale = moment(investmentData.investment_updated_at);
  localLocale.locale(getI18n().language);
  const lineColor =
    investmentData.business_line == ICampaingTypes.Shares
      ? "#7D7BFA"
      : investmentData.business_line == ICampaingTypes.ConvertibleNote
      ? "#496CFF"
      : "#04A3AE";
  const lineIcon =
    investmentData.business_line == ICampaingTypes.Shares
      ? infoIconShares
      : investmentData.business_line == ICampaingTypes.ConvertibleNote
      ? infoIconConvertibleNote
      : infoIconDebt;

  const validHelp = () => {
    let widthInvestmentDestinyName: any = document.getElementById(
      `investment_destiny_name_${investmentData.id}`
    );
    if (
      widthInvestmentDestinyName?.scrollHeight >
      widthInvestmentDestinyName?.offsetHeight
    ) {
      setHelp(true);
    } else {
      setHelp(false);
    }
  };

  useEffect(() => {
    validHelp();
    window.addEventListener("resize", validHelp, false);
  });

  const renderAccordionItems = () => {
    const isMobileCard = isPhone;

    const businessLineBlock = (
      <div className="investment__business-line">
        <div
          className={`investment__tags ${
            investmentData.business_line == ICampaingTypes.Shares
              ? "Shares"
              : investmentData.business_line == ICampaingTypes.ConvertibleNote
              ? "ConvertibleNote"
              : investmentData.business_line == ICampaingTypes.Debt
              ? "Debt"
              : ""
          }`}
          style={{ background: lineColor, color: "white", padding: "8px 12px", borderRadius: "4px", fontWeight: 700, lineHeight: "16px", display: "flex", gap: "8px", alignItems: "center", fontSize: "12px", boxSizing: "border-box", whiteSpace: "nowrap" }}
        >
          {t(`businessLines.${BusinessLine[investmentData.business_line]}`)}
          <img
            id="id-icon-rtt"
            src={lineIcon}
            alt="info"
            data-tip={`tag_line_Accordion_${investmentData.id}`}
            data-for={`tag_line_Accordion_${investmentData.id}`}
            className="investment__tags__icon"
            style={{ width: "16px", height: "16px", flexShrink: 0, cursor: "pointer" }}
          />
          <ReactTooltip
            className={`investment__tooltip ${
              investmentData.business_line == ICampaingTypes.Debt
                ? "tooltip_accordeon_deb"
                : investmentData.business_line == ICampaingTypes.Shares
                ? "tooltip_accordeon_share"
                : investmentData.business_line == ICampaingTypes.ConvertibleNote
                ? "tooltip_accordeon_note"
                : ""
            }`}
            id={`tag_line_Accordion_${investmentData.id}`}
            place="top"
            effect="solid"
            placement="topCenter"
            offset={{ top: 8 }}
          >
            <div>
              {investmentData.business_line == ICampaingTypes.Shares
                ? "Inviertes comprando acciones de una empresa para volverte su socio"
                : investmentData.business_line == ICampaingTypes.ConvertibleNote
                ? "Instrumento financiero que te da el derecho a recibir acciones de una empresa si se cumplen las condiciones de conversión de la nota."
                : investmentData.business_line == ICampaingTypes.Debt
                ? "Es un préstamo que le haces a la empresa y del cual recibes una rentabilidad periódica."
                : ""}
            </div>
          </ReactTooltip>
        </div>
      </div>
    );

    const statusBlock =
      investmentData.campaign_state == ICampaingState.Open ? (
        <div className="investment__status" style={{ display: "flex", alignItems: "center", gap: isMobileCard ? "12px" : "0px", padding: isMobileCard ? "0 4px" : undefined, fontSize: "12px", lineHeight: "16px", color: "#475061", fontWeight: 400 }}>
          <div
            className={`investment__status__oval ${investmentData.investment_state}`}
            style={{
              width: "12px",
              height: "12px",
              borderRadius: "9999px",
              background: investmentData.investment_state === "exchange" ? "#FDDA25" : "#39FBBF",
              outline: "2px solid #A2AAAD",
              outlineOffset: "-1px",
              margin: isMobileCard ? 0 : undefined,
              flexShrink: 0
            }}
          ></div>
          {t(`investment.investmentsList.${investmentData.investment_state}`)}
        </div>
      ) : null;

    const destinyBlock = (
      <div
        id={`investment_destiny_${investmentData.id}`}
        className="investment__destiny"
      >
        <div
          id={`investment_destiny_name_${investmentData.id}`}
          data-tip={help ? investmentData.campaign_name : ""}
          className={`investment__destiny__name ${
            investmentData.business_line == ICampaingTypes.Shares
              ? "Shares_text"
              : investmentData.business_line == ICampaingTypes.ConvertibleNote
              ? "ConvertibleNote_text"
              : investmentData.business_line == ICampaingTypes.Debt
              ? "Debt_text"
              : ""
          }`}
          data-testid="campaign-link"
          style={{ fontSize: "16px", color: "#475061", fontWeight: 400 }}
        >
          <span className="investTo" id={`investTo_${investmentData.id}`}>
            {t("investment.investmentsList.investTo")}
          </span>{" "}
          <span
            className="campaign_name"
            id={`campaign_name_${investmentData.id}`}
            data-testid="spanCampaignName"
            onClick={() =>
              dispatch(
                CampaignsDetailActions.getCampaingData(
                  investmentData.campaign_id,
                  getHasSession()
                )
              )
            }
            style={{ color: lineColor, fontWeight: 700, textDecoration: "underline", cursor: "pointer" }}
          >
            {investmentData.campaign_name}
          </span>
        </div>
        <ReactTooltip effect="solid" className="tooltip_text_destiny" />
      </div>
    );

    const isOpen = active === investmentData.id;
    const chevronBlock = (
      <div className="icon" style={{ display: "flex", alignItems: "flex-start", padding: "8px", margin: 0, cursor: "pointer", color: "#475061" }}>
        <label htmlFor={investmentData.id} style={{ cursor: "pointer", display: "inline-flex" }}>
          <img
            src={chevronIcon}
            alt=""
            width="24"
            height="24"
            style={{
              transform: isOpen ? "none" : "rotate(180deg)",
              transition: "transform 0.2s ease"
            }}
          />
        </label>
      </div>
    );

    return (
      <>
        <div className="investment">
          <p className="investment__date">
            {`${t(
              `investment.investmentsList.date${
                investmentData.investment_state === "canceled" ? "Canceled" : ""
              }`
            )} ${capitalizeWord(
              localLocale.format("dddd, D")
            )} de ${capitalizeWord(localLocale.format("MMMM YYYY"))}`}
          </p>
          <div className="investment__accordion-item">
            <input
              className="investment__accordion-checkbox"
              type="checkbox"
              id={investmentData.id}
              data-testid="accordionCheckbox"
              onChange={() => {
                const itemActivated =
                  active === investmentData.id ? 0 : investmentData.id;
                setActive(itemActivated);
              }}
              checked={active === investmentData.id}
            />
            <label className="investment__accordion-label" style={{ display: "flex", width: "100%", flexDirection: isMobileCard ? "column" : "row", padding: isMobileCard ? "16px" : "8px 24px", alignItems: isMobileCard ? "stretch" : "center", justifyContent: "space-between", gap: isMobileCard ? "16px" : undefined, boxSizing: "border-box", borderBottom: isMobileCard ? "none" : "1px solid #D4D7D9" }}>
              {isMobileCard ? (
                <>
                  <div style={{ display: "flex", width: "100%", justifyContent: "space-between", alignItems: "flex-start" }}>
                    <div className="investment__accordion-info" style={{ display: "flex", flexDirection: "column", gap: "16px", alignItems: "flex-start" }}>
                      {businessLineBlock}
                      {statusBlock}
                    </div>
                    {chevronBlock}
                  </div>
                  <div style={{ width: "100%" }}>{destinyBlock}</div>
                </>
              ) : (
                <>
                  <div className="investment__accordion-info" style={{ display: "flex", gap: "4px", alignItems: "center" }}>
                    {businessLineBlock}
                    {statusBlock}
                  </div>
                  <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "flex-start", gap: "32px" }}>
                    <div style={{ padding: "8px 20px" }}>{destinyBlock}</div>
                    {chevronBlock}
                  </div>
                </>
              )}
            </label>
            <div className="investment__content" style={{ padding: isMobileCard ? "0" : "24px", boxSizing: "border-box", display: "block" }}>
              <InvestDetail investDetail={investmentData} />
            </div>
          </div>
        </div>
      </>
    );
  };

  return renderAccordionItems();
};

InvestListAccordion.propTypes = {
  investmentData: PropTypes.shape({
    id: PropTypes.number,
    campaign_id: PropTypes.number,
    campaign_name: PropTypes.string,
    investment_state: PropTypes.string,
    business_line: PropTypes.number
  }).isRequired
};

export default InvestListAccordion;
